import { render } from "./NewsHeadLine.vue?vue&type=template&id=6519c909&scoped=true"
import script from "./NewsHeadLine.vue?vue&type=script&lang=js"
export * from "./NewsHeadLine.vue?vue&type=script&lang=js"

import "./NewsHeadLine.vue?vue&type=style&index=0&id=6519c909&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Admin\\source\\MFVK\\menu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6519c909"]])

export default __exports__